import { useNavigate, useLocation } from "react-router-dom";
import { useCourseDetailStore } from "@/stores/courseDetailStore";
import { useCourseBasePath } from "@/hooks/useCourseBasePath";
import { IntroModal } from "@/components/course/IntroModal";
import { COURSE_INTRO_FALLBACK } from "@/components/course/introFallbacks";

export const CourseIntroPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const basePath = useCourseBasePath();
  const { courseData, courseTitle } = useCourseDetailStore();

  const firstModule = courseData?.structure?.[0];

  const handleStart = () => {
    if (firstModule) {
      navigate(`${basePath}/${firstModule.id}${location.search}`);
    }
  };

  return (
    <IntroModal
      title={courseTitle ?? ""}
      body={courseData?.intro || COURSE_INTRO_FALLBACK}
      ctaLabel="Mit dem Kurs anfangen"
      onStart={handleStart}
    />
  );
};
